import { createPubSubHooks } from "@/shared/utils/pubSub";

type Callback = (param: { fieldName: string; index: number }) => void;
export const [useRemoveFieldTrigger, useOnRemoveField] = createPubSubHooks<Callback>();
